import type { ReactNode } from 'react';
import { toast } from '@skupreme/shared/ui';
import { ErrorMessageConstant } from './constants/common';
import { CommonUtility } from './common';

/*
 * EN-4544: the app's toasts are the design system's (`toast`, shown by the ToastRegion DeployWatcher mounts). The
 * calls keep their old shape, so every caller works unchanged; the legacy icon argument no longer changes anything.
 */
export class ToastMessage {
  static success = (message: ReactNode, _iconType?: string) => {
    toast.success(message);
  };

  static error = (message: unknown, _iconType?: string) => {
    toast.error(
      CommonUtility.isString(message)
        ? message
        : ErrorMessageConstant.defaultAPIError,
    );
  };

  static apiError = err => {
    const { error, message } = err;
    const errorMessage =
      typeof error === 'string'
        ? error
        : typeof message === 'string'
          ? message
          : ErrorMessageConstant.defaultAPIError;

    this.error(errorMessage);
  };

  static warning = (message: ReactNode, _iconType?: string) => {
    toast.warning(message);
  };

  static info = (message: ReactNode, _iconType?: string) => {
    toast.info(message);
  };

  static clear = () => {
    toast.clear();
  };
}
